import 'fslightbox';
import AnchorPolyfill from './modules/anchor-polyfill.js';
import utilities from './modules/utilities';
import Glides from './modules/glide';
import Modal from './modules/modal';
import Map from './modules/map';

document.querySelector('.embed-youtube') ? loadYtVideoLazyload() : '';

async function loadYtVideoLazyload() {
    const { ytVideoLazyload } = await import('./modules/yt-video-lazyload');
    ytVideoLazyload();
}

window.addEventListener('DOMContentLoaded', () => {
    //put navbar height below
    new AnchorPolyfill(90);
    utilities();
    Glides();
    Modal();
    Map();
});
